import { Star } from "phosphor-react";
import React from "react";

const Index = ({ data }) => {
  return (
    <>
      <div className="space-y-7 p-4 rounded-2xl bg-white">
        <div className="flex items-end justify-between w-full">
          <div className="flex items-center space-x-4">
            <img
              className="w-12 h-12 rounded-full"
              src={data.user.avatar}
              alt=""
            />
            <div>
              <h1 className="text-lg font-medium">{data.user.name}</h1>
              <h1 className="text-sm text-slate-400">{data.time}</h1>
            </div>
          </div>
          <div className="flex items-end justify-end space-x-1 text-yellow-400">
            <Star size={24} weight="fill" />
            <Star size={24} weight="fill" />
            <Star size={24} weight="fill" />
            <Star size={24} weight="fill" />
            <Star size={24} weight="fill" />
          </div>
        </div>
        <div className="bg-slate-100 rounded-xl p-3 h-44 lg:h-36">
          <h1 className="text-slate-900 font-bold text-lg mb-4">
            {data.title}
          </h1>
          <h1 className="text-slate-600 text-base">
            {data.text.length >= 160 ? `${data.text}...` : data.text}
          </h1>
        </div>
      </div>
    </>
  );
};

export default Index;
